<template>
  <div class="report">
    <Form inline >
      <FormItem v-if="quesList.length > 1">
        <Select v-model="ques_id" style="width:200px;margin-right:20px" :transfer="true" @on-change="selectQues">
          <Option
            v-for="item in quesList"
            :value="item.questionnaire_id"
            :key="item.questionnaire_id"
          >{{ item.questionnaire_name }}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="!haveData">
          <Select v-model="tj_id" style="width:200px" :transfer="true" @on-change="selectQues">
            <Option
              v-for="item in tjList"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
      </FormItem>
    </Form>
    <div style="padding: 100px;" v-if="haveData && subjectResponseList.length === 0">
      <div class="caring-nodata">
        <i class="iconfont icon-wushuju"></i>
        <slot name="message">
          <div>暂无相关数据</div>
        </slot>
      </div>
    </div>
    <div v-if="!haveData">
      <div class="report_t" v-if="ques_id" style="margin-bottom:20px">
        <Checkbox v-model="single" style="font-size:14px">仅查看筛选条件中的题目</Checkbox>
      </div>

      <div class="report_content">
        <div class="list" style="margin-bottom:15px" v-for="(item,index) in list" :key="index">
          <div v-if="item.type == 'SingleChoiceQuestion'">
            <div>{{index + 1}}、[单选] {{item.value.singleChoiceAttribute.name}}</div>
            <div class="radio">
              <div v-for="(i,j) in item.value.singleChoiceOptions" :key="j">{{i.name}}</div>
            </div>
            <Table :width="800" border :columns="columns" :data="item.choose.optionResponseList">
              <template slot-scope="{row}" slot="optionLabel">
                <template>{{row.optionLabel }}</template>
              </template>
              <template slot-scope="{row}" slot="optionNum">
                <template>{{row.optionNum || '--'}}</template>
              </template>
              <template slot-scope="{row}" slot="percent">
                <template>
                  <Progress v-if="row.ratio != 100" :percent="row.ratio" />
                  <Progress v-else class="progress1 mPercent" :percent="100">
                    <span>100%</span>
                  </Progress>
                </template>
              </template>
              <!-- <template slot-scope="{row, index}" slot="action">
                <caring-button @click="look(row, index)">查看</caring-button>
              </template>-->
            </Table>
          </div>
          <div v-else-if="item.type == 'MultipleChoiceQuestion'">
            <div>{{index + 1}}、[多选] {{item.value.multipleChoiceAttribute.name}}</div>
            <div class="radio">
              <div v-for="(i,j) in item.value.multipleChoiceOptions" :key="j">{{i.name}}</div>
            </div>
            <Table :width="800" border :columns="columns" :data="item.choose.optionResponseList">
              <template slot-scope="{row}" slot="optionLabel">
                <template>{{row.multipleOptionLabel.join(",")}}</template>
              </template>
              <template slot-scope="{row}" slot="optionNum">
                <template>{{row.optionNum || '--'}}</template>
              </template>
              <template slot-scope="{row}" slot="percent">
                <template>
                  <Progress v-if="row.ratio != 100" :percent="row.ratio" />
                  <Progress v-else class="progress1 mPercent" :percent="100">
                    <span>100%</span>
                  </Progress>
                </template>
              </template>
              <!-- <template slot-scope="{row, index}" slot="action">
                <caring-button @click="look(row, index)">查看</caring-button>
              </template>-->
            </Table>
          </div>
          <!-- 单行文本题 -->
          <div v-else-if="item.type == 'SingleLineTextQuestion'">
            <div>{{index + 1}}、[单行文本题] {{item.value.singleLineTextAttribute.name}}</div>
            <div>
              <Input
                placeholder="请输入关键字段"
                size="large"
                v-model="searchText"
                clearable
                style="width:300px;margin:20px 0"
              />
              <Button type="primary" @click="onSearch(item,index)">搜 索</Button>
            </div>
            <Table
              :width="800"
              max-height="300"
              border
              :columns="columnsText"
              :data="item.choose.optionResponseList"
            >
              <template slot-scope="{row}" slot="userName">
                <template>{{row.userName }}</template>
              </template>
              <template slot-scope="{row}" slot="optionLabel">
                <template>{{row.optionLabel}}</template>
              </template>
              <template slot-scope="{row}" slot="createDate">
                <template>{{row.createDate}}</template>
              </template>
            </Table>
            <!-- <div style="margin-top:16px;width:800px;text-align:right;" v-if="!isSearch">
              <Page
                :total="item.choose.optionResponseList[0] ? item.choose.optionResponseList[0].length : item.choose.optionResponseList.length"
                :current="current"
                :page-size="size"
                :page-size-opts="sizes"
                :show-total="true"
                :show-elevator="false"
                :show-sizer="false"
                @on-change="onCurrentChange"
                @on-page-size-change="onSizeChange"
              />
            </div>-->
          </div>
          <!-- 数字题 -->
          <div v-else-if="item.type == 'DigitalQuestion' || item.type == 'FillInBlankQuestion'">
            <div>{{index + 1}}、{{questionType(item.type)}} {{questionTitle(item)}}</div>
            <div>
              <Input
                placeholder="请输入关键字段"
                size="large"
                v-model="item.searchText"
                clearable
                style="width:300px;margin:20px 0"
              />
              <Button type="primary" @click="onSearch(item,index)">搜 索</Button>
            </div>
            <Table
              :width="800"
              max-height="300"
              border
              :columns="columnsText"
              :data="item.choose.optionResponseList"
            >
              <template slot-scope="{row}" slot="userName">
                <template>{{row.userName }}</template>
              </template>
              <template slot-scope="{row}" slot="optionLabel">
                <template>{{row.optionLabel || row.multipleOptionLabel}}</template>
              </template>
              <template slot-scope="{row}" slot="createDate">
                <template>{{row.createDate}}</template>
              </template>
            </Table>
            <!-- <div style="margin-top:16px;width:800px;text-align:right;" v-if="!isSearch">
              <Page
                :total="item.choose.optionResponseList[0] ? item.choose.optionResponseList[0].length : item.choose.optionResponseList.length"
                :current="current"
                :page-size="size"
                :page-size-opts="sizes"
                :show-total="true"
                :show-elevator="false"
                :show-sizer="false"
                @on-change="onCurrentChange"
                @on-page-size-change="onSizeChange"
              />
            </div>-->
          </div>

          <div
            v-if="item.type == 'SingleChoiceQuestion' || item.type == 'MultipleChoiceQuestion'"
            class="btns"
            style="margin: 20px 0;"
          >
            <Button type="primary" icon="md-grid" round style="margin-right:10px">表格</Button>
            <Button
              v-for="(items,sonIndex) in buttonArray"
              :key="sonIndex"
              :icon="items.icon"
              :class="sonIndex == item.buttonIndex ? 'active':''"
              @click="drawLine(items.type,index,sonIndex)"
              style="margin-right:10px"
              round
            >{{items.name}}</Button>
          </div>
          <!-- 趋势图 -->
          <div
            v-if="item.type == 'SingleChoiceQuestion' || item.type == 'MultipleChoiceQuestion'"
            class="charts"
          >
            <div
              :id="'confirmed-pie' + index + item.buttonIndex"
              v-show="item.buttonIndex == '0'"
              :style="{width: '400px', height: '250px'}"
            ></div>
            <div
              :id="'confirmed-circle' + index + item.buttonIndex"
              v-show="item.buttonIndex == '1'"
              :style="{width: '400px', height: '250px'}"
            ></div>
            <div
              :id="'confirmed-bar' + index + item.buttonIndex"
              v-show="item.buttonIndex == '2'"
              :style="{width: '400px', height: '250px'}"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="dialogFormVisible"
      draggable
      footer-hide
      title="人员列表"
      :z-index="999"
      :width="810"
    >
      <div :style="{'max-height': (windowHeight - 100 * 2 - 150) + 'px'}" style="overflow-y:auto;">
        <Table
          :columns="columnsPerson"
          ref="selection"
          stripe
          :data="personLists"
          :border="false"
          @on-selection-change="ssss"
          :loading="loading"
        >
          <template slot-scope="{row}" slot="name">
            <template>{{row.patient_name && row.patient_name}}</template>
          </template>
          <template slot-scope="{row}" slot="gender">
            <template>{{row.gender == 0 ? '女' : '男' || '--'}}</template>
          </template>
          <template slot-scope="{row}" slot="age">
            <template>{{row.age || '--'}}</template>
          </template>
          <template slot-scope="{row}" slot="phone">
            <template>{{row.phone || '--'}}</template>
          </template>
          <template slot-scope="{row}" slot="create_time">
            <template>{{row.create_time && row.create_time.substring(0, 16)}}</template>
          </template>
        </Table>
        <div style="margin-top:16px;text-align:right;">
          <Page
            :total="total_"
            :current="current_"
            :page-size="size_"
            :page-size-opts="sizes"
            :show-total="true"
            :show-elevator="false"
            :show-sizer="false"
            @on-change="personChange"
            @on-page-size-change="personSizeChange"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts')
// 引入折线图
require('echarts/lib/chart/pie')
require('echarts/lib/chart/bar')
// 引入提示框组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: 'filterAnalysis',
  props: {
    quesList: {
      type: Array,
      required: true,
    },
    list_info: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      haveData: false,
      subjectResponseList: [],
      buttonArray: [
        {
          type: 'pie',
          icon: 'md-pie',
          name: '饼状图',
        },
        {
          type: 'circle',
          icon: 'md-radio-button-off',
          name: '圆环图',
        },
        {
          type: 'bar',
          icon: 'md-stats',
          name: '柱状图',
        },
      ],
      list: [],
      columns: [
        {
          title: '选项',
          slot: 'optionLabel',
          align: 'center',
        },
        {
          title: '小计（有效填写人次）',
          key: 'optionNum',
          align: 'center',
        },
        {
          title: '比例',
          slot: 'percent',
          align: 'center',
        },
        // {
        //   title: '查看人员',
        //   slot: 'action',
        //   width: 200,
        //   align: 'center',
        // },
      ],
      type: 'pie',
      searchText: '',
      columnsText: [
        {
          title: '姓名',
          slot: 'userName',
          align: 'center',
          fixed: 'center',
        },
        {
          title: '文本内容',
          key: 'optionLabel',
          align: 'center',
          fixed: 'center',
        },
        {
          title: '填写时间',
          slot: 'createDate',
          align: 'center',
        },
      ],
      total: 0,
      current: 1,
      size: 5,
      sizes: [20, 30, 40, 50],
      isSearch: false,
      single: false,
      total_: 0,
      current_: 1,
      size_: 10,
      columnsPerson: [
        {
          title: '姓名',
          slot: 'name',
          align: 'center',
        },
        {
          title: '性别',
          slot: 'gender',
          align: 'center',
        },
        {
          title: '年龄',
          slot: 'age',
          align: 'center',
        },
        {
          title: '手机号',
          slot: 'phone',
          align: 'center',
        },
        {
          title: '填写时间',
          slot: 'create_time',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
        },
      ],
      dialogFormVisible: false,
      personLists: [],
      loading: false,
      ques_id: '',
      quesInfo: {},
      tj_id:'0',
      tjList:[
        {
          id:'0',
          name:'统计最新'
        },
        {
          id:'1',
          name:'统计所有'
        }
      ]
    }
  },

  components: {},
  methods: {
    questionType(type) {
      let res = ''
      if (type == 'DigitalQuestion') {
        res = '[数字题]'
      } else if (type == 'FillInBlankQuestion') {
        res = '[填空题]'
      }
      return res
    },
    questionTitle(item) {
      let res = ''
      // console.log(item)
      if (item.type == 'DigitalQuestion') {
        res = item.value.digitalAttribute.name
      } else if (item.type == 'FillInBlankQuestion') {
        res = item.value.fillInBlanksAttribute.name
      }
      return res
    },
    selectQues() {
      let self = this
      let info = {}

      self.quesList.forEach((v) => {
        if (self.ques_id == v.questionnaire_id) {
          info = v
        }
      })
      self.statisQuery(info)
    },
    statisQuery: function (info) {
      let self = this
      if (self.quesList.length > 1) {
        self.$utils.loadingShow()
      }
      self.$utils.caringRequest({
        method: 'POST',
        url: self.$utils.getInterface('STATIS_QUERY'),
        headers: {
          'content-type': 'application/json',
        },
        data: {
          questionId: info.questionnaire_id,
          moduleQueryList: info.template_module.moduleQueryList,
          uniqueIdRange: self.tj_id == '0' ?  info.last_unique_id_range  : info.unique_id_range,
        },
        surplusHeader: true,
        success: function (res) {
          if (self.quesList.length > 1) {
            self.$utils.loadingHide()
          }
          if (res.code === 0) {
            self.quesInfo = res.data
            self.init()
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    init: function () {
      let self = this
      let list = self.quesInfo.questionInfo.questions
      let subjectResponseList = self.quesInfo.subjectResponseList
      let subjectIdAll = self.quesInfo.subjectIdAll //筛选的题目

      subjectIdAll.forEach((v) => {
        if (v.includes('||')) {
          v.split('||')
          subjectIdAll = v.split('||')
        }
      })

      self.subjectResponseList = subjectResponseList
      if (subjectResponseList.length == 0) {
        self.haveData = true
        return
      } else {
        self.haveData = false
      }
      // return
      // 筛选选中的题目
      if (self.single) {
        let arr = []
        let questionCondition = []
        subjectResponseList.forEach(function (j, index) {
          subjectIdAll.forEach(function (m, inx) {
            if (m == j.subjectId) {
              arr.push(j)
            }
          })
        })
        list.forEach(function (v) {
          arr.forEach(function (j) {
            if (j.subjectId == v.value.id) {
              v.choose = j
              self.$set(v, 'buttonIndex', '0')
              questionCondition.push(v)
            }
          })
        })
        self.list = questionCondition
      } else {
        list.forEach(function (v) {
          subjectResponseList.forEach(function (j) {
            if (j.subjectId == v.value.id) {
              v.choose = j
              self.$set(v, 'buttonIndex', '0')
            }
          })
          if (
            v.type == 'SingleLineTextQuestion' ||
            v.type == 'DigitalQuestion' ||
            v.type == 'FillInBlankQuestion'
          ) {
            if (v.options) {
              return
            }
            self.$set(v, 'options', v.choose.optionResponseList)
            // let objArray = v.choose.optionResponseList
            // let len = objArray.length
            // let n = self.size //假设每行显示4个
            // let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1)
            // let res = []
            // for (let i = 0; i < lineNum; i++) {
            //   let temp = objArray.slice(i * n, i * n + n)
            //   res.push(JSON.parse(JSON.stringify(temp)))
            // }

            // v.choose.optionResponseList = res
          }
        })
        self.list = list
      }

      // console.log(self.list)

      // return
      self.list.forEach(function (v, index) {
        if (
          v.type == 'SingleChoiceQuestion' ||
          v.type == 'MultipleChoiceQuestion'
        ) {
          self.drawLine('pie', index, 0)
        }
      })
    },
    drawLine: function (type, index, sonIndex) {
      let self = this
      self.type = type
      self.$set(self.list[index], 'buttonIndex', sonIndex)
      let myChart

      if (
        self.list[index].type == 'SingleChoiceQuestion' ||
        self.list[index].type == 'MultipleChoiceQuestion'
      ) {
        self.$nextTick(function () {
          if (type == 'pie') {
            myChart = echarts.init(
              document.getElementById('confirmed-pie' + index + sonIndex)
            )
          } else if (type == 'circle') {
            myChart = echarts.init(
              document.getElementById('confirmed-circle' + index + sonIndex)
            )
          } else if (type == 'bar') {
            myChart = echarts.init(
              document.getElementById('confirmed-bar' + index + sonIndex)
            )
          }
          // 绘制图表
          let data = []
          let xAxis = []
          let yAxis = []
          let optionResponseList = self.list[index].choose.optionResponseList
          // console.log(optionResponseList)
          optionResponseList.forEach(function (v) {
            let obj = {}
            // 多选
            if (self.list[index].type == 'MultipleChoiceQuestion') {
              obj.name = v.multipleOptionLabel.join(',')
              xAxis.push(v.multipleOptionLabel.join(','))
            } else {
              obj.name = v.optionLabel
              xAxis.push(v.optionLabel)
            }
            obj.ratio = v.ratio
            obj.value = v.optionNum
            data.push(obj)
            yAxis.push(v.optionNum)
          })

          let series = [
            {
              name: '',
              type: 'pie',
              radius: '50%',
              center: ['30%', '40%'],
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
              label: {
                show: false,
                position: 'center',
              },
              labelLine: {
                show: false,
              },
            },
          ]
          if (type == 'circle') {
            series = [
              {
                name: '',
                type: 'pie',
                radius: ['20%', '50%'],
                center: ['30%', '40%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2,
                },
                label: {
                  show: false,
                  position: 'center',
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '40',
                    fontWeight: 'bold',
                  },
                },
                labelLine: {
                  show: false,
                },
                data: data,
              },
            ]
          } else if (type == 'bar') {
            myChart.setOption({
              tooltip: {
                trigger: 'axis',
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: xAxis,
                  axisTick: {
                    alignWithLabel: true,
                  },
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              color: ['#538dfa', '#f5ca54', '#49c2a8', '#ff960d'],
              series: [
                {
                  name: '',
                  type: 'bar',
                  barWidth: '60%',
                  data: yAxis,
                  itemStyle: {
                    normal: {
                      //这里是重点
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#538dfa',
                          '#f5ca54',
                          '#49c2a8',
                          '#ff960d',
                        ]
                        return colorList[params.dataIndex]
                      },
                    },
                  },
                },
              ],
            })
            return
          }
          myChart.setOption({
            tooltip: {
              trigger: 'item',
            },
            legend: {
              icon: 'circle',
              orient: 'circle',
              top: '10%',
              right: '0%',
              formatter: function (name) {
                var total = 0
                var tarValue, p
                for (var i = 0; i < data.length; i++) {
                  total += data[i].value
                  if (data[i].name == name) {
                    tarValue = data[i].value
                    p = data[i].ratio
                  }
                }
                var v = tarValue
                // var p = Math.round((tarValue / total) * 100)
                return `${name}  ${v}人(${p}%)`
              },
            },
            color: ['#538dfa', '#f5ca54', '#49c2a8', '#ff960d'],
            series: series,
          })
        }, 0)
      }
    },
    look: function (row) {
      // console.log(row)
      this.dialogFormVisible = true
      this.personLists = []
      let uniqueIdList = row.uniqueIdList ? row.uniqueIdList : row.uniqueId
      this.getRecord(uniqueIdList)
    },
    getRecord: function (uniqueIdList) {
      this.loading = true
      this.$utils.caringRequest({
        method: 'POST',
        url: this.$utils.getInterface('FILTRATE_QUESTIONNAIRE_RECORD'),
        data: {
          questionnaire_id: this.quesInfo.questionId,
          unique_ids: uniqueIdList,
          page: this.current_,
          size: this.size_,
        },
        success: (res, response) => {
          this.total_ = res.data.total_elements
          this.loading = false
          if (res.code === 0) {
            this.personLists = res.data.content
          } else {
            this.$Message.error(res.message)
          }
        },
      })
    },
    personChange(current) {
      this.current_ = current
      this.getList()
    },
    personSizeChange(size) {
      this.size_ = size
      this.getList()
    },
    ssss(status, row) {
      // console.log(status, row)
      this.unique_ids = []
      status.forEach((val) => {
        this.unique_ids.push(val.unique_id)
      })
    },
    onSearch: function (item, index) {
      var self = this
      self.getList(item, index)
    },
    onCurrentChange: function (current) {
      this.current = current
    },
    onSizeChange: function (size) {
      this.size = size
    },
    getList: function (item, index) {
      // console.log(item, index)
      // console.log(item.searchText)
      let self = this
      let lists = JSON.parse(JSON.stringify(item.options))
      let objArray = lists.filter(
        (j) => j.optionLabel.indexOf(item.searchText) != -1
      )

      // let len = objArray.length
      // let n = self.size //假设每行显示4个
      // let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1)
      // let res = []
      // for (let i = 0; i < lineNum; i++) {
      //   let temp = objArray.slice(i * n, i * n + n)
      //   res.push(JSON.parse(JSON.stringify(temp)))
      // }
      // console.log(objArray)
      item.choose.optionResponseList = objArray
    },
    download: function () {},
    patientDetail: function (i) {
      // console.log(i)
      this.dialogFormVisible = false
      if (!i.patient_id) {
        this.getPatientId(i)
        return
      }
      // 查看患者详情
      this.$utils.openPage({
        type: 'patientDetailNew',
        title: i.patient_name,
        id: i.patient_id,
        params: {
          user_id: i.patient_id,
        },
      })
    },
    getPatientId: function (i) {
      let self = this
      self.$utils.caringRequest({
        method: 'GET',
        url:
          self.$utils.getInterface('FILTRATE_PATIENT_UNIQUEID') +
          '/' +
          i.uniqueId,

        success: function (res) {
          if (res.code === 0) {
            // 查看患者详情
            self.$utils.openPage({
              type: 'patientDetailNew',
              title: res.data.name,
              id: res.data.id,
              params: {
                user_id: res.data.id,
              },
            })
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
  },
  mounted: function () {},
  watch: {
    quesList: {
      handler(nv, ov) {
        this.quesList = nv

        if (this.list_info.length > 0) {
          this.statisQuery(this.quesList[0])
          this.ques_id = this.quesList[0].questionnaire_id
          this.$forceUpdate()
        } else {
          this.haveData = true
          this.subjectResponseList = []
        }
      },
      deep: true,
    },

    single: function (val) {
      this.single = val
      this.init()
    },
  },
  computed: {
    windowHeight: function () {
      return window.innerHeight
    },
  },
}
</script>

<style lang="less" >
@import '../../../styles/common.less';
.report {
  padding: 5px 20px;
   .caring-nodata {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -150px;
    margin-top: -100px;
    width: 300px;
    height: 200px;
    text-align: center;
    color: @disabled-color;
    padding: 20px;

    i.iconfont {
      font-size: 80px;
    }
  }
  .report_t {
    i {
      width: 5px;
      height: 13px;
      background: #ffa615;
      border-radius: 5px;
      display: inline-block;
      margin-right: 6px;
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .report_content {
    .radio {
      margin: 20px 0;
      div {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
  .ivu-btn.active {
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
  }
  .ivu-progress-show-info .ivu-progress-outer {
    padding-right: 65px;
    margin-right: -65px;
    float: left;
  }
}
</style>
